module.exports = __webpack_public_path__ + "img/1.6.CODm.2eaca28f.png";